import React, { useState } from 'react';
import { Box, Chip, TextField, Typography } from '@mui/material';

// Shared "Cc:" editor used by every recruitment email composer/preview
// (selection, next-round, interview schedule) so they all behave identically:
// removable chips + an input to add addresses (Enter / comma / blur), with
// basic email validation and de-duplication.
export const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || '').trim());

export default function CcEditor({ value = [], onChange, accent = '#2f6bff' }) {
  const [input, setInput] = useState('');

  const add = () => {
    const v = input.trim().replace(/,$/, '').trim();
    if (!v || !isValidEmail(v)) return;
    if (!value.includes(v)) onChange([...value, v]);
    setInput('');
  };
  const remove = (addr) => onChange(value.filter((a) => a !== addr));

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      <Typography variant="body2" sx={{ mt: 0.9, fontWeight: 700, flexShrink: 0 }}>Cc:</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', flex: 1 }}>
        {value.map((addr) => (
          <Chip
            key={addr}
            label={addr}
            size="small"
            onDelete={() => remove(addr)}
            sx={{ bgcolor: '#eef4ff', color: accent, fontWeight: 600 }}
          />
        ))}
        <TextField
          variant="standard"
          placeholder={value.length ? 'Add Cc…' : 'Add a Cc email…'}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(); }
          }}
          onBlur={add}
          error={!!input && !isValidEmail(input)}
          helperText={!!input && !isValidEmail(input) ? 'Enter a valid email' : ''}
          sx={{ minWidth: 150, flex: 1, '& .MuiInput-input': { fontSize: '0.85rem', py: 0.4 } }}
        />
      </Box>
    </Box>
  );
}
